import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { DatabaseUserGroup } from 'src/modules/database/shared/database-user-group.model';
import { TableData } from '../../models/table-data.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { TableColumn } from '../../models/table-column.model';
import { TableRow } from '../../models/table-row.model';
import { TableSortColumn } from '../../models/table-sort-column.model';
import { TableCellType } from '../../models/table-cell-type.enum';

@Component({
  selector: 'app-edit-general-user-groups',
  templateUrl: './edit-general-user-groups.component.html',
  styleUrl: './edit-general-user-groups.component.scss'
})
export class EditGeneralUserGroupsComponent extends ComponentView {

    listData: DatabaseUserGroup[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.listData = await this.app.loadDataHandler(async () => RestEndpoint.main().find({source: ""}).run("api/app/usergroup").list(DatabaseUserGroup), this);

        this.table = new TableData([
            new TableColumn("name", "Name", TableCellType.text, { autoWidth: 30 })
        ], this.listData.map(o => new TableRow("", o, {
            name: o.name
        })), [new TableSortColumn("name")]);
        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] },
            { label: "Benutzergruppen", routerLink: ["/base2", "admin", "editGeneralUserGroups"] }
        ]);
        return true;
    }
}